// extracted by mini-css-extract-plugin
export default {"search_bar":"Searchbar_search_bar__mUKw-"};